<template>
    <div>
        <div class="flex justify-between mt-0 px-4 p-3 pt-0" @click="collapsed = !collapsed">
            <p class="font-semibold capitalize text-lg">Dispatch Information</p>
            <p class="flex gap-2 items-center cursor-pointer" v-if="collapsed">
                <span>
                    <svg width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M12.6466 8.5L13.7644 7.38219L6.88219 0.5L0 7.38219L1.11781 8.5L6.88219 2.73562L12.6466 8.5Z"
                            fill="#10233E" />
                    </svg>
                </span>
                Collapse
            </p>
            <p class="flex gap-2 items-center cursor-pointer" v-else>
                <span>
                    <svg width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M12.6466 0.5L13.7644 1.61781L6.88219 8.5L0 1.61781L1.11781 0.5L6.88219 6.26438L12.6466 0.5Z"
                            fill="#321C3B" />
                    </svg>
                </span>
                Expand
            </p>
        </div>
        <div v-if="collapsed"  class="p-4">
            <div class="flex flex-wrap p-2 pl-3 mb-3 rounded-lg borrder border-gray-400 w-full">
                <div class="w-full md:w-1/2 mb-3">
                    <h3 class="text-green text-base font-semibold mb-3">VEHICLE INFO</h3>
                    <div class="detailsItem">
                        <p class="w-1/3 text-gray-500 flex flex-wrap">
                            <span class="w-auto">Vehicle No:</span>
                        </p>
                        <p class="w-2/3 font-semibold text-left ">
                            {{ shippingTimeline?.vehicleInfo?.vehicleNo }}
                        </p>
                    </div>

                    <div class="detailsItem">
                        <p class="w-1/3 text-gray-500 flex flex-wrap">
                            <span>Driver:</span>
                        </p>
                        <p class="w-2/2 font-semibold text-left">
                            {{
                                shippingTimeline?.vehicleInfo?.driver
                            }}
                        </p>
                    </div>

                    <div class="detailsItem">
                        <p class="w-1/3 text-gray-500 flex flex-wrap">
                            <span>Contact No:</span>
                        </p>
                        <p class="w-2/3 font-semibold text-left">
                            {{
                                 shippingTimeline?.vehicleInfo?.contactNo
                            }}
                        </p>
                    </div>

                    <div class="detailsItem">
                        <p class="w-1/3 text-gray-500 flex flex-wrap"><span class=" whitespace-nowrap">Vehicle
                                Capacity:</span>
                        </p>
                        <p class="w-2/3 font-semibold text-left">{{  shippingTimeline?.vehicleInfo?.vehicleCapacity }} 
                        </p>
                    </div>
                </div>
                <div class="w-full md:w-1/2 mb-3">
                    <h3 class="text-green text-base font-semibold  mb-3">SHIPPING SERVICE</h3>

                    <div class="detailsItem justify-start">
                        <p class="w-1/3 text-gray-500 flex flex-wrap"><span>Name:</span>
                        </p>
                        <p class="w-2/3 font-semibold text-left">{{ shippingTimeline?.shippingService?.name}}</p>
                    </div>
                    <div class="detailsItem">
                        <p class="w-1/3 text-gray-500 flex flex-wrap"><span>Businness Address:</span>
                        </p>
                        <p class="w-2/3 font-semibold text-left">{{ shippingTimeline?.shippingService?.businessAddress }}</p>
                    </div>
                    <div class="detailsItem">
                        <p class="w-1/3 text-gray-500 flex flex-wrap"><span>Phone Number:</span>
                        </p>
                        <p class="w-2/3 font-semibold text-left">{{  shippingTimeline?.shippingService?.phoneNumber  }}</p>
                    </div>
                    <div class="detailsItem">
                        <p class="w-1/3 text-gray-500 flex flex-wrap"><span>Email Address:</span></p>
                        <p class="w-2/3 font-semibold text-left">{{ shippingTimeline?.shippingService?.emailAddress }}</p>
                    </div>
                </div>
            </div>
            <hr class="my-3 mt-4" />
            <div class="flex flex-wrap p-2 pl-3">
                <div class="md:w-1/2 w-full mb-3">
                    <h3 class="text-green text-base font-semibold  mb-3">FROM</h3>
                    <div class="detailsItem">
                        <p class="w-1/3 text-gray-500 flex flex-wrap"><span>Name:</span>
                        </p>
                        <p class="w-2/3 font-semibold text-left">{{ shippingTimeline?.from?.name }}</p>
                    </div>
                    <div class="detailsItem">
                        <p class="w-1/3 text-gray-500 flex flex-wrap"><span>Address:</span> </p>
                        <p class="w-2/3 font-semibold text-left">{{shippingTimeline?.from?.address}}, {{shippingTimeline?.from?.city}}, {{shippingTimeline?.from?.state}}</p>
                    </div>
                    <div class="detailsItem">
                        <p class="w-1/3 text-gray-500 flex flex-wrap"><span>Dispatched by</span>
                        </p>
                        <p class="w-2/3 font-semibold text-left">{{ shippingTimeline?.from?.dispatchedBy }}</p>
                    </div>
                    <div class="detailsItem">
                        <p class="w-1/3 text-gray-500 flex flex-wrap"><span>Contact No:</span>
                        </p>
                        <p class="w-2/3 font-semibold text-left">{{ shippingTimeline?.from?.contactNo }}</p>
                    </div>
                    <div class="detailsItem">
                        <p class="w-1/3 text-gray-500 flex flex-wrap"><span>Contact Email:</span>
                        </p>
                        <p class="w-2/3 font-semibold text-left">{{ shippingTimeline?.from?.contactEmail }}</p>
                    </div>
                </div>
                <div class="md:w-1/2 w-full mb-3">
                    <h3 class="text-green text-base font-semibold  mb-3">TO</h3>

                    <div class="detailsItem">
                        <p class="w-1/3 text-gray-500 flex flex-wrap">
                            <span>Name:</span>
                        </p>
                        <p class="w-2/3 font-semibold text-left">
                            {{ shippingTimeline?.to?.name  }}
                        </p>
                    </div>
                    <div class="detailsItem">
                        <p class="w-1/3 text-gray-500 flex flex-wrap">
                            <span>Email:</span>
                        </p>
                        <p class="w-2/3 font-semibold text-left">
                           {{ shippingTimeline?.to?.contactEmail }}
                        </p>
                    </div>
                    <div class="detailsItem">
                        <p class="w-1/3 text-gray-500 flex flex-wrap">
                            <span>Manager:</span>
                        </p>
                        <p class="w-2/3 font-semibold text-left">{{  shippingTimeline?.to?.manager }}</p>
                    </div>
                    <div class="detailsItem">
                        <p class="w-1/3 text-gray-500 flex flex-wrap">
                            <span>Contact No:</span>
                        </p>
                        <p class="w-2/3 font-semibold text-left">{{ shippingTimeline?.to?.contactNo }}</p>
                    </div>
                    <div class="flex flex-wrap">
                        <p class="w-1/3 text-gray-500 flex flex-wrap">
                            <span>Contact Email:</span>
                        </p>
                        <p class="w-2/3 font-semibold text-left">{{shippingTimeline?.to?.contactEmail }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            collapsed: false
        }
    },
    props: {
        shippingTimeline: {}
    },
    methods: {
        formatAmount(number) {
            return number ? number.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0;
        },
        statusColors(status) {
            const opac = "25";
            switch (status) {
                case "paid":
                    return { color: "#09B78A", backgroundColor: "#09B78A" + opac };
                case "pending":
                    return { color: "#FFA600", backgroundColor: "#FCC21040" };
            }
        },
    },

}
</script>

<style lang="scss" scoped>
.box_wrapper {
    @apply border-t border-b border-gray-300 flex flex-wrap mt-3;

    div {
        @apply w-full sm:w-6/12 py-4 px-4
    }
}

.trans_item {
    @apply w-full sm:w-6/12 md:w-4/12 lg:w-3/12 mb-4;

    b {
        @apply font-[600]
    }
}

.order_status {
    @apply text-sm whitespace-nowrap capitalize text-ellipsis overflow-hidden rounded-2xl py-1.5 px-6
}
.detailsItem{
  @apply flex flex-wrap mb-1
}
.top_list_item_title {
  @apply font-semibold flex-1 mt-1 text-base
}

.top_list_item_img {
  @apply mt-1 -mr-8 w-14
}
</style>